
import { reactive} from "vue";
import DynamicForm from "@/components/Shared/Dynamicform/DynamicForm.vue";

export default {
  name: "WildBookFallData",
  inheritAttrs: false,
  components: {
    DynamicForm
  },
  setup() {
    const request = reactive({
      apiLoadMethod: "",
      apiSaveMethod: "",
      form: "WildbuchEintragFallwild",
      page: "WildbuchEintragFallwildDaten",
      remoteId: "",
     

      

    });
    return {
      request
    };
  }
};
